/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Loading"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enUS = Object.assign(TranslationProviderComponent, {
  translations
});

export { enUS as e };
//# sourceMappingURL=en-US-DcONpFWf.js.map
